module.exports = __webpack_public_path__ + "media/images/banner-assets/en/banner0-a03e91cdf1f2da18898a9394cfc5f0a9.jpg";